import {AriaModal} from '../library/_aria';
import loadStatus from '../library/_loadStatus';
import userAgent from '../library/_userAgent';
import {applySoundCookie, toggleSound, turnOnSound, turnOffSound, playSE} from '../modules/_sound';
import '../library/_trueVh';
import {emphasisEffect, unEffect} from '../modules/_keyAnimation';
import 'lazysizes';

export default {
  init() {
    // JavaScript to be fired on all pages

    // ローディング状態
    loadStatus();

    // ユーザーエージェント判定
    userAgent()

    /**
     * ハンバーガーメニュー
     */
    const menu = document.getElementById('menu');
    const menuAria = new AriaModal(menu);
    menuAria.setToggle('click', (aria)=>{
      console.log(aria);
    });

    /**
     * ゴーストヘッダー
     * FVから下にスクロールすると、ヘッダーが表示される。
     */
    const fv = document.getElementById('fv');
    const ghostHeader = document.getElementById('ghostHeader')
    const CLASS_NAME_VISIBLE = 'is-visible';
    if(fv && ghostHeader) {
      const isobOption = {
        root: null,
        rootMargin: '0px',
        threshold: [0,0.1,1],
      }
      const isob = new IntersectionObserver((entries)=> {
        entries.forEach(entry => {
          const ratio = entry.intersectionRatio;
          if(ratio <= 0.1) {
            ghostHeader.classList.add(CLASS_NAME_VISIBLE);
          } else {
            // ハンバーガーメニューが開いている時は実行しない
            if(!document.querySelector('.header__ghost-inner.-menu').classList.contains('is-active')) {
              ghostHeader.classList.remove(CLASS_NAME_VISIBLE);
            }
          }
        })
      }, isobOption)
      isob.observe(fv);
    }

    /**
     * サウンド切り替え
     */
    const btnSound = document.getElementById('btnSound');
    if(btnSound) {
      btnSound.addEventListener('click', toggleSound);
    }
    const btnSoundSp = document.getElementById('btnSoundSp');
    if(btnSoundSp) {
      btnSoundSp.addEventListener('click', toggleSound);
    }
    const opSoundOn = document.getElementById('opSoundOn');
    if(opSoundOn) {
      opSoundOn.addEventListener('click', turnOnSound);
    }
    const opSoundOff = document.getElementById('opSoundOff');
    if(opSoundOff) {
      opSoundOff.addEventListener('click', turnOffSound);
    }
    const playerBtn = document.getElementById('playerBtn');
    if(playerBtn) {
      playerBtn.addEventListener('click', ()=>{turnOffSound(false)});
    }

    /**
     * 画面遷移へのインターセプト
     */
    const links = document.querySelectorAll('a');
    if(links.length) {
      links.forEach(link => {
        if(!link.classList.contains('no-effect') && link.getAttribute('target') !== '_blank') {
          link.addEventListener('click', evt => {
            evt.preventDefault();
            console.log(link.href);
            playSE({fadeout: true, scale: 10, left: 10, delay: 100});
            emphasisEffect();
            window.setTimeout(()=>{
              location.href = link.href;
            }, 2000)
          });
        }
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // サウンド設定を取得・適用
    applySoundCookie();

    // サウンド関連 iPhone対策
    const bgAudio = document.querySelector('#bgAudio');
    if(bgAudio && bgAudio.readyState < 4) bgAudio.load();

    const effectAudio = document.querySelector('#effectAudio');
    if(effectAudio && effectAudio.readyState < 4) effectAudio.load();
  },
};

//safari ブラウザバックを検出して強制的にエフェクトを戻す
window.onpageshow = function(event) {
  if (event.persisted) {
    unEffect();
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js